import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo, {"duration":1000,"ease":[0.4,0,0.14,1]})

export default function (ctx, inject) {
    inject('scrollTo', VueScrollTo.scrollTo)
}
